// extracted by mini-css-extract-plugin
export var loadingSpinner = "_17-0";
export var spinnerContainer = "_17-1";